export enum DashboardMasterAttributes {
    ChartType = 1,
    FilterOption = 2,
    DateFilter = 3,
    FilterPopup = 4
}
